import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

export const BasicInfoTab = ({ formMode }: { formMode: 'add' | 'edit' | 'view'; activeGroup?: string }) => {
  const rowClassName = 'flex min-w-0 items-center';
  const labelClassName = 'w-40 min-w-40 shrink-0';
  const fieldClassName = 'min-w-0 flex-1';
  const textFieldClassName = 'w-full max-w-[360px]';

  return (
    <div className='min-w-0 max-w-full overflow-x-hidden p-4'>
      <div className='flex flex-col space-y-4'>
        {/* Thông tin nhóm vật tư */}
        <div className={rowClassName}>
          <Label className={labelClassName}>Mã nhóm</Label>
          <div className={fieldClassName}>
            <FormField type='text' name='ma_nhom' className={textFieldClassName} disabled={formMode === 'view'} />
          </div>
        </div>

        <div className={rowClassName}>
          <Label className={labelClassName}>Tên phân nhóm</Label>
          <div className={fieldClassName}>
            <FormField type='text' name='ten_phan_nhom' className={textFieldClassName} disabled={formMode === 'view'} />
          </div>
        </div>

        <div className={rowClassName}>
          <Label className={labelClassName}>Tên 2</Label>
          <div className={fieldClassName}>
            <FormField type='text' name='ten2' className={textFieldClassName} disabled={formMode === 'view'} />
          </div>
        </div>

        <div className={rowClassName}>
          <Label className={labelClassName}>Trạng thái</Label>
          <div className={fieldClassName}>
            <FormField
              type='select'
              name='trang_thai'
              className={textFieldClassName}
              options={[
                { value: '1', label: '1. Còn sử dụng' },
                { value: '0', label: '0. Không sử dụng' }
              ]}
              defaultValue={'1'}
              disabled={formMode === 'view'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
